// extracted by mini-css-extract-plugin
module.exports = {"Roll":"Roll_Roll__1c8Mg"};